import { ChevronDown, LogOut, User } from 'lucide-react'
import { useTheme } from 'next-themes'
import logoAvansuite from '@/assets/logo-avansuite.svg'
import logoAvansuiteDark from '@/assets/logo-avansuite_dark.svg'
import { ThemeToggle } from '@/components/ThemeToggle'
import { Badge } from '@/components/ui/badge'
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Separator } from '@/components/ui/separator'
import { useBoundStore } from '@/store/useBoundStore'

export function Header() {
	const user = useBoundStore((state) => state.user)
	const isAuthenticated = useBoundStore((state) => state.isAuthenticated)
	const logout = useBoundStore((state) => state.logout)
	const isAdmin = useBoundStore((state) => state.isAdmin)
	const isManager = useBoundStore((state) => state.isManager)
	const isEmployee = useBoundStore((state) => state.isEmployee)
	const { theme } = useTheme()

	const getUserRole = () => {
		if (isAdmin()) return 'Administrador'
		if (isManager()) return 'Manager'
		if (isEmployee()) return 'Empleado'
		return 'Usuario'
	}

	const getRoleVariant = (): 'default' | 'secondary' | 'outline' => {
		if (isAdmin()) return 'default'
		if (isManager()) return 'secondary'
		return 'outline'
	}

	return (
		<header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
			<div className="container mx-auto flex h-16 items-center justify-between px-4">
				<div className="flex items-center gap-4">
					<img
						src={theme === 'dark' ? logoAvansuiteDark : logoAvansuite}
						alt="Avansuite Logo"
						className="h-14 w-auto"
					/>
					{isAuthenticated() && user && (
						<>
							<Separator orientation="vertical" className="h-6" />
							<div className="hidden md:flex items-center gap-2">
								<span className="text-sm text-muted-foreground">
									{user.company?.name || 'Sin empresa'}
								</span>
							</div>
						</>
					)}
				</div>

				<div className="flex items-center gap-4">
					<ThemeToggle />
					{isAuthenticated() && user && (
						<DropdownMenu>
							<DropdownMenuTrigger asChild>
								<button className="flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium hover:bg-accent hover:text-accent-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 transition-colors">
									<span>{user.name}</span>
									<ChevronDown className="h-4 w-4 text-muted-foreground" />
								</button>
							</DropdownMenuTrigger>
							<DropdownMenuContent align="end" className="w-56">
								<DropdownMenuLabel>
									<div className="flex flex-col space-y-1">
										<p className="text-sm font-medium leading-none">{user.name}</p>
										{user.email && (
											<p className="text-xs leading-none text-muted-foreground">{user.email}</p>
										)}
									</div>
								</DropdownMenuLabel>
								<DropdownMenuSeparator />
								<DropdownMenuLabel>
									<div className="flex flex-col space-y-1">
										<p className="text-xs text-muted-foreground">Empresa</p>
										<p className="text-sm font-medium">{user.company?.name || 'Sin empresa'}</p>
									</div>
								</DropdownMenuLabel>
								<DropdownMenuSeparator />
								<div className="px-2 py-1.5">
									<Badge variant={getRoleVariant()} className="w-full justify-center">
										<User className="mr-2 h-3 w-3" />
										{getUserRole()}
									</Badge>
								</div>
								<DropdownMenuSeparator />
								<DropdownMenuItem onClick={logout} variant="destructive">
									<LogOut className="mr-2 h-4 w-4" />
									<span>Cerrar sesión</span>
								</DropdownMenuItem>
							</DropdownMenuContent>
						</DropdownMenu>
					)}
				</div>
			</div>
		</header>
	)
}
